import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Button, Text } from 'components/common/Elements/Elements';

import classes from './ResultAlert.module.scss';

const ResultAlert = ({ data }) => {
  const {
    count,
    version,
    platform,
    arch,
    kind = 'success',
    isNotFiltered
  } = data;
  const history = useHistory();
  const { t } = useTranslation(['activity']);

  const goToLog = () => {
    history.push('/cs/versions-activity-log');
  };

  return (
    <div className={classes.result}>
      {kind === 'success' ? (
        <Text>
          Version
          <Text
            className={cn(classes.platform, classes.blue)}
          >{` ${platform}`}</Text>
          <Text className={classes.blue}>{` ${arch} ${version} `}</Text>
          was successfully released to
          <Text className={classes.blue}>
            {` ${
              count === 0
                ? isNotFiltered
                  ? 'All Tenants.'
                  : 'All Filtered Tenants.'
                : count
            } `}
          </Text>
          {count > 0 && t('activity:customers.customers')}
        </Text>
      ) : (
        <Text>
          Version
          <Text
            className={cn(classes.platform, classes.red)}
          >{` ${platform}`}</Text>
          <Text className={classes.red}>{` ${arch} ${version} `}</Text>
          wasn&apos;t released.
        </Text>
      )}

      <Button onClick={goToLog} className={classes.button}>
        View Version Log
      </Button>
    </div>
  );
};

ResultAlert.propTypes = {
  data: PropTypes.shape({
    count: PropTypes.number,
    version: PropTypes.string,
    platform: PropTypes.string,
    arch: PropTypes.string,
    kind: PropTypes.string,
    isNotFiltered: PropTypes.bool
  })
};

export default ResultAlert;
